import { FieldOption } from '@components/form/v2';

import { useFormBuilderContext } from '../context';
import { FieldContainingOptions } from '../state';
import { filterOutExcludedOptions } from '../utils';

export const useFieldOptions = (field: FieldContainingOptions): FieldOption[] => {
  const { predefinedOptionsLists } = useFormBuilderContext();

  if (!field.optionsFromListId) {
    return field.options;
  }

  const list = predefinedOptionsLists.find((list) => list.value === field.optionsFromListId);
  const excludedOptions = field.excludedOptions ?? [];
  return list ? filterOutExcludedOptions(list.options, excludedOptions) : [];
};
